// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ButtonActions, ButtonSizes, ButtonSpans, ButtonTypes } from '../button.model';

@Component({
  selector: 'e-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnChanges, OnInit {

  @Input() type : ButtonTypes | string = ButtonTypes.Primary;
  @Input() action : ButtonActions | string = ButtonActions.Button;
  @Input() size : ButtonSizes | string = ButtonSizes.Regular;
  @Input() span : ButtonSpans | string = ButtonSpans.Regular;
  @Input() full = true;
  @Input() disabled = false;

  @Output() eButtonClick = new EventEmitter<any>();

  cssClasses: string[];

  ngOnInit(): void {
    this.refreshClasses();
  }

  ngOnChanges(): void {
    this.refreshClasses();
  }

  propagateClick(event) {
    this.eButtonClick.emit(event);
  }

  private refreshClasses(): void {
    this.cssClasses = this.getClasses();
  }

  private getClasses(): string[] {
    return [
      'button--' + this.type,
      'button--' + this.size,
      'button--span-' + this.span,
      this.full ? 'button--full' : '',
    ];
  }
}
